import request from '../../utils/request'
// 提现详情
const withdrawDetail = (data) => {
  return request({
      url: `/mp/fission/withdraw/detail`,
      method: 'get',
  })
}
// 提现操作
const withdrawHandle = (data) => {
  return request({
      url: `/mp/fission/withdraw/handle`,
      method: 'post',
      data
  })
}


export {
  withdrawDetail,
  withdrawHandle
}